import React, { Component } from 'react';

export default class StabSearchBox extends Component {
  shouldComponentUpdate() {
    return false;
  }

  render() {
    return (
      <div
        id="stab-searchbox"
        className="mobile-inline"
        dangerouslySetInnerHTML={{ __html: this.props.markup }}
        suppressHydrationWarning
      />
    );
  }
}
